import React from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { Avatar, Button, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setSignOut } from "../redux/reducers/auth";
import createCardIcon from "./Main/assets/treatmentPlanIcon.png";
import LazySpinner from "./LazySpinner";
import { blue, red } from "@mui/material/colors";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

// import { useGetPackageDetailsQuery } from "../../redux/packagesApi";

export const SignInBtn = () => {
  const { t: _t } = useTranslation();

  return (
    <Button variant="outlined" color="white" to="/sign-in" component={RouterLink} sx={{ mr: 1 }}>
      {_t("Sign in")}
    </Button>
  );
};

export const SignUpBtn = () => {
  const { t: _t } = useTranslation();

  return (
    <Button variant="outlined" color="white" to="/sign-up" component={RouterLink}>
      {_t("Sign up")}
    </Button>
  );
};

export const SignOutBtn = ({ color = "white" }) => {
  const { t: _t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <Button
      variant="outlined"
      color={color}
      onClick={() => {
        dispatch(setSignOut());
        dispatch({ type: "DESTROY_SESSION" });
        navigate("/", { replace: true });
      }}
    >
      {_t("Sign out")}
    </Button>
  );
};

export const ProfileBtn = () => {
  const { t: _t } = useTranslation();

  return (
    <Button variant="contained" color="primary" to="/company" component={RouterLink} sx={{ mr: 1 }}>
      {_t("Profile")}
    </Button>
  );
};

export const TreatmentPlanBtn = () => {
  const { t: _t } = useTranslation();
  // const { data: packageDetails, isLoading: isPackageDetailsLoading } =
  //   useGetPackageDetailsQuery();

  // if (isPackageDetailsLoading) {
  //   return <LazySpinner />;
  // }

  return (
    <Button
      to="/treatment-plan"
      component={RouterLink}
      variant="contained"
      color="primary"
      startIcon={<Avatar sx={{ width: 66, height: 44 }} variant="square" src={createCardIcon} />}
      // disabled={!packageDetails.cardCreationEnabled}
    >
      {_t("Create a treatment plan")}
    </Button>
  );
};

export const ColorButton = styled(Button, { shouldForwardProp: (prop) => prop !== "color" && prop !== "deg" })(
  ({ theme, deg = 0 }) => ({
    color: theme.palette.getContrastText(blue[500]),
    background: `linear-gradient(${deg}deg, ${red[200]} 0%, ${blue[200]} 100%)`,
    "&:hover": {
      background: `linear-gradient(${deg}deg, ${red[300]} 0%, ${blue[300]} 100%)`,
    },
  })
);

export const HtmlTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(
  ({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: blue[400],
      color: "#fff",
      maxWidth: 400,
      textAlign: "center",
      fontSize: theme.typography.pxToRem(16),
      padding: "8px 8px",
      [`& .${tooltipClasses.arrow}`]: {
        color: blue[400],
      },
    },
  })
);
